export default __webpack_public_path__ + "static/media/8.4f5f0dfb.jpg";